function setLinkListHeights(linkLists) {
    for (var a = 0, l = linkLists.length; a < l; a++) {
        linkLists[a].setAttribute('data-height',linkLists[a].scrollHeight);
    }
}

export function setupEntrances() {
    const entrancesItems = document.querySelectorAll('.entrances__list > .entrances__item');
    const entrancesLinkLists = document.querySelectorAll('.entrances .entrances__link-list');

    setLinkListHeights(entrancesLinkLists);

    function clickEntrance(e) {
        const item = e.target.closest('.entrances__item');
        const itemList = e.target.closest('.entrances__list');

        if (item != undefined && itemList != undefined) {
            const allItems = itemList.querySelectorAll('.entrances__item');
            const currentActiveItem = Array.prototype.slice.call(allItems).filter(x => x.classList.contains('js-active'));

            function updateListview(itemList,item) {
                itemList.classList.add('js-open');
                item.classList.add('js-active');
            }

            if (currentActiveItem.length == 1) {
                if (currentActiveItem != item) {
                    currentActiveItem[0].classList.remove('js-active');

                    const activeItemLinkList = currentActiveItem[0].querySelector('.entrances__link-list');

                    if (activeItemLinkList != undefined) {
                        activeItemLinkList.style.height = '0';
                    }

                    updateListview(itemList, item);
                }
            } else {
                updateListview(itemList, item);
            }

            const itemLinkList = item.querySelector('.entrances__link-list');

            if (itemLinkList != undefined) {
                itemLinkList.style.height = `${itemLinkList.getAttribute('data-height')}px`;
            }
        }
    }

    for (let a = 0, l = entrancesItems.length; a < l; a++) {
        entrancesItems[a].addEventListener('click', clickEntrance);
    }
}